<template>
    <v-dialog v-model="controls.showDialog" max-width="800" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable persistent>
        <template v-slot:activator="{on}">
            <slot name="activator" :on="on">

            </slot>
        </template>
        <v-card :loading="controls.loading">
            <v-card-title>Add to route: {{route.name}}</v-card-title>
            <v-divider></v-divider>
            <v-card-actions v-if="controls.customerExists" class="pa-0">
                <v-spacer></v-spacer>
                <v-alert class="ma-0" type="error" dense>Customer is already scheduled for today.</v-alert>
                <v-spacer></v-spacer>
            </v-card-actions>
            <v-card-text>
                <v-form v-model="controls.validForm" ref="form" @submit.prevent>
                    <v-autocomplete
                            v-model="form.customer"
                            label="Select customer"
                            item-text="primary_name.name"
                            :items="queried.customers"
                            :rules="[formRules.required]"
                            @change="customerSelected()"
                            return-object
                    >
                    </v-autocomplete>
                    <v-checkbox
                            v-model="form.recurring"
                            label="Is Recurring"
                    >
                    </v-checkbox>
                    <i v-if="form.recurring">Select days <strong>{{form.customer ? form.customer.primary_name.name : 'they'}}</strong> should be scheduled</i>
                    <v-row justify="space-around" v-if="form.recurring">
                        <v-checkbox
                                v-model="form.days.sunday"
                                label="sunday"
                        >
                        </v-checkbox>
                        <v-checkbox
                                v-model="form.days.monday"
                                label="monday"
                        >
                        </v-checkbox>
                        <v-checkbox
                                v-model="form.days.tuesday"
                                label="tuesday"
                        >
                        </v-checkbox>
                        <v-checkbox
                                v-model="form.days.wednesday"
                                label="wednesday"
                        >
                        </v-checkbox>
                        <v-checkbox
                                v-model="form.days.thursday"
                                label="thursday"
                        >
                        </v-checkbox>
                        <v-checkbox
                                v-model="form.days.friday"
                                label="friday"
                        >
                        </v-checkbox>
                        <v-checkbox
                                v-model="form.days.saturday"
                                label="saturday"
                        >
                        </v-checkbox>
                    </v-row>
                    <div class="title" v-else>Schedule for: {{date}}</div>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-btn @click="close" :disabled="controls.loading" text>close</v-btn>
                <v-spacer></v-spacer>
                <v-btn @click="save()" color="success" :disabled="!controls.validForm || controls.loading || controls.customerExists">submit</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import belit from '../../../Lib/Belit'
    import firebase from 'firebase/app';
    import 'firebase/firestore';
    export default {
        name: "AddToRoute",
        data: () => ({
            controls:{
                showDialog: false,
                loading: false,
                validForm: true,
                customerExists: false,
            },
            form: {
                customer: null,
                recurring: false,
                days: {
                    sunday: false,
                    monday: false,
                    tuesday: false,
                    wednesday: false,
                    thursday: false,
                    friday: false,
                    saturday: false,
                }
            },
            formRules: {
                required: v => !!v || "This field is required"
            },
            queried: {
                customers: [],
            }
        }),
        props:{
            route: {
                type: Object,
                required: true
            },
            date: {
                type: String,
                required: true,
            },
            day: {
              type: String,
              required: true
            }
        },
        mounted(){
            this.getCustomers();
        },
        methods:{
            close(){
              this.controls.showDialog = false;
              this.$refs.form.reset();
            },
            async getCustomers(){
                this.controls.loading = true;
                let response = await belit.get('/customers', {
                    with: 'primaryName,addresses',
                    where: {
                      key: 'id',
                      value: 90
                    }
                });
                this.controls.loading = false;
                this.queried.customers= response.data;
            },
            async customerSelected(){
              this.$emit('clearMarkers');
              this.controls.loading = true;
              let address = this.form.customer.addresses.filter(address => address.address_type.desc === "Physical");
              if(address.length > 0){
                  address = address[0];
                  this.$emit('showLocation', {lat: address.lat, lon: address.lon, name: this.form.customer.primary_name.name});
              }
              let customers = await this.$firestore
                  .collection('scheduled')
                  .where('customer_id', '==', this.form.customer.id)
                  .where('date', '==', this.date)
                  .get()
              if(customers.size > 0){
                this.controls.customerExists = true;
                this.controls.loading = false;
              }else{
                console.log(this.day);
                customers = await this.$firestore
                    .collection('scheduled_recurring')
                    .where('customer_id', '==', this.form.customer.id)
                    .where(`days.${this.day}`, '==', true)
                    .get()
                this.controls.loading = false;
                if(customers.size > 0 && customers.size < 2){
                  this.controls.customerExists = true;
                }else{
                  this.form.recurring = false;
                  this.controls.customerExists = false;
                  this.form.days = {
                    sunday: false,
                    monday: false,
                    tuesday: false,
                    wednesday: false,
                    thursday: false,
                    friday: false,
                    saturday: false,
                  }
                }
              }

            },
            async save(){
                this.controls.loading = true;
                let address = this.form.customer.addresses.filter(address => address.address_type.desc === "Physical");
                if(address.length === 0){
                    this.$store.dispatch("showError", "Customer does not have a physical address stored.");
                    this.controls.loading = false;
                    return;
                }
                let customerObject = {
                  customer_id: this.form.customer.id,
                  address: address[0],
                  route_id: this.route.id,
                }
                if(this.form.recurring){
                  customerObject.days = {...this.form.days}
                }else{
                  customerObject.date = this.date;
                }
                let store;
                    try{
                      let collection = this.form.recurring ? 'scheduled_recurring' : "scheduled";
                      if(this.controls.editing){
                        store = this.$firestore.collection(collection).doc(this.form.editingId).update(customerObject)
                      }else{
                        store = this.$firestore.collection(collection).doc().set(customerObject)
                      }
                      this.$store.dispatch("showSuccess", "Scheduled customer!");
                      this.$refs.form.reset();
                      this.controls.editing = false;
                      this.form.editingId = null
                      this.controls.loading = false;
                    }catch(err){
                      this.controls.loading = false;
                      this.$store.dispatch("showError", "Failed to store/update customer")
                    }
            },
        },
    }
</script>

<style scoped>

</style>
